import styled from "styled-components";

export const CamposContainer = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  p {
    font-size: 13px;
    color: var(--color-text-muted, #68737d);
  }
`;

export const ButtonContainerStyled = styled.div`
  margin-top: auto;
  margin-bottom: 0;
  margin-left: auto;
`;
